import type { AfterContentChecked } from '@angular/core';
import { Component, Input, ViewChild } from '@angular/core';
import { makeProvider } from '@shared/form-fields/make-provider';
import { AbstractFormFieldComponent } from '../abstract-form-field/abstract-form-field.component';

@Component({
    selector: 'app-data-field',
    styleUrls: ['./data-field.component.scss'],
    template: `
        <div class="app-data-field"
             [class.is-empty]="isEmpty">
            <label>
                {{ label }}
                <ng-content select="[appLabel]"></ng-content>
            </label>

            <div class="app-data-field-inner">
                <div class="app-data-field-content"
                     #content>
                    {{ value }}
                    <ng-content></ng-content>
                </div>

                <div class="app-data-field-empty-message" *ngIf="isEmpty">
                    {{ empty }}
                </div>

                <div class="app-data-field-suffix">
                    <ng-content select="[appSuffix]"></ng-content>
                </div>
            </div>

            <div class="app-data-field-hint"
                 #hintElement
                 [class.hint-empty]="isHintEmpty">
                <ng-content select="app-hint"></ng-content>
                <ng-content select="[appHint]"></ng-content>
                {{ hint }}
            </div>
        </div>
    `,
    providers: [makeProvider(DataFieldComponent)],
})
export class DataFieldComponent extends AbstractFormFieldComponent<string> implements AfterContentChecked {
    @Input() label: string;
    @Input() hint: string;
    @Input() empty: string;

    @ViewChild('content', { static: true }) contentElement;
    @ViewChild('hintElement', { static: true }) hintElement;

    isEmpty = false;
    isHintEmpty = false;

    ngAfterContentChecked(): void {
        const content = this.contentElement.nativeElement.textContent.trim();
        const hint = this.hintElement.nativeElement.textContent.trim();

        this.isEmpty = content.length === 0;
        this.isHintEmpty = hint.length === 0;
    }
}
